module.exports = __webpack_public_path__ + "static/media/cmr_10.c8c1907e.jpg";